import { Reveal } from "./Reveal";
import { SERVICES } from "@/data/content";

export const Services = () => (
  <section id="services" data-testid="services" className="bg-[#080808] border-y border-white/10">
    <div className="max-w-[1500px] mx-auto px-6 md:px-12 py-28 md:py-40">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16 md:mb-24">
        <Reveal className="md:col-span-5">
          <p className="overline text-[#d4af37] mb-6">What We Do</p>
          <h2 className="font-serif font-light text-4xl md:text-6xl leading-[1.02] tracking-tight text-white">
            A full advisory line, from feasibility to closeout.
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-6 md:col-start-7 flex items-end">
          <p className="text-white/60 font-light leading-relaxed text-base md:text-lg">
            Ten disciplines, one mandate — protect the owner’s capital and deliver the project.
            Engage the full scope or a single service where you need it most.
          </p>
        </Reveal>
      </div>

      <div className="border-t border-white/10">
        {SERVICES.map((s, i) => (
          <Reveal key={s.no} delay={(i % 2) * 0.06}>
            <div
              data-testid={`service-${s.no}`}
              className="svc-row group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 items-center border-b border-white/10 py-8 md:py-10"
            >
              <span className="md:col-span-1 overline text-[#d4af37]">{s.no}</span>
              <h3 className="md:col-span-4 font-serif text-2xl md:text-3xl text-white group-hover:text-[#d4af37] transition-colors duration-500">
                {s.title}
              </h3>
              <p className="md:col-span-7 text-white/55 font-light leading-relaxed">
                {s.desc}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
